"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.to-string");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _system = require("@/api/system");
var _operation = require("@/api/operation");
var _default = exports.default = {
  directives: {
    waves: _waves.default
  },
  filters: {
    areaCodeFilter: function areaCodeFilter(val) {
      try {
        if (val && val.length > 0) {
          return JSON.parse(val).toString();
        }
      } catch (e) {
        console.log('areaCode解析失败: ', e);
      }
      return 'ALL';
    }
  },
  data: function data() {
    return {
      listLoading: false,
      list: [],
      roleList: [{
        label: '超管',
        value: 'superAdmin'
      }, {
        label: '运营',
        value: 'operation'
      }, {
        label: '客服',
        value: 'customer'
      }, {
        label: '高级运营',
        value: 'admin'
      }, {
        label: '合作方',
        value: 'partner'
      }, {
        label: '财务',
        value: 'finance'
      }, {
        label: '市场部',
        value: 'finance'
      }],
      dialogVisible: false,
      dialogType: 'new',
      formData: {
        username: '',
        role: ''
      },
      rules: {
        username: {
          required: true,
          message: "".concat(this.$t('form.pleaseEnter')).concat(this.$t('form.userName')),
          trigger: 'blur'
        }
      },
      areaCodeList: [],
      roleLists: []
    };
  },
  created: function created() {
    this.getRoleList();
    this.getAreaList();
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$adminAccountLi, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _system.adminAccountList)(this.listQuery);
            case 1:
              _yield$adminAccountLi = _context.v;
              code = _yield$adminAccountLi.code;
              data = _yield$adminAccountLi.data;
              this.listLoading = false;
              if (code === 0) {
                this.list = data.list;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    delAdmin: function () {
      var _delAdmin2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(row) {
        var _this = this;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.$confirm('确定删除该账户吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
                var _yield$_delAdmin, code;
                return (0, _regenerator2.default)().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return (0, _system.delAdmin)({
                        username: row.username
                      });
                    case 1:
                      _yield$_delAdmin = _context2.v;
                      code = _yield$_delAdmin.code;
                      if (code === 0) {
                        _this.$message({
                          message: '删除成功',
                          type: 'success'
                        });
                      }
                      _this.getList();
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function delAdmin(_x) {
        return _delAdmin2.apply(this, arguments);
      }
      return delAdmin;
    }(),
    handleEdit: function handleEdit(row) {
      if (row) {
        this.dialogType = 'edit';
        this.formData = JSON.parse(JSON.stringify(row));
        this.formData.area_code = this.formData.area_code && JSON.parse(this.formData.area_code);
      } else {
        this.dialogType = 'new';
        this.formData = {
          username: '',
          role: ''
        };
      }
      this.dialogVisible = true;
    },
    confirmRole: function confirmRole() {
      var _this2 = this;
      this.$refs.editForm.validate(/*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(valid) {
          var role, _yield$editAdmin, code, data;
          return (0, _regenerator2.default)().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                if (valid) {
                  _context4.n = 1;
                  break;
                }
                return _context4.a(2, false);
              case 1:
                role = _this2.roleLists.filter(function (item) {
                  return item.role_id === _this2.formData.role_id;
                });
                _this2.formData.role = role[0].name;
                _context4.n = 2;
                return (0, _system.editAdmin)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this2.formData), {}, {
                  type: _this2.dialogType
                }));
              case 2:
                _yield$editAdmin = _context4.v;
                code = _yield$editAdmin.code;
                data = _yield$editAdmin.data;
                if (code === 0) {
                  _this2.$message({
                    message: _this2.dialogType === 'edit' ? _this2.$t('form.editSuccess') : _this2.$t('form.addSuccess'),
                    type: 'success'
                  });
                  if (_this2.dialogType === 'new') {
                    _this2.$confirm("".concat(_this2.formData.username, "\u7684\u521D\u59CB\u767B\u9646\u5BC6\u7801\u4E3A").concat(data.pwd, "\uFF0C\u8BF7\u59A5\u5584\u4FDD\u7BA1"), '警告', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    });
                  }
                  _this2.dialogVisible = false;
                  _this2.getList();
                }
              case 3:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    resetGoogle: function resetGoogle(row) {
      var _this3 = this;
      this.$confirm('确定要重置该账号的谷歌身份验证吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var _yield$resetGoogleAut, code;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return (0, _system.resetGoogleAuth)({
                username: row.username
              });
            case 1:
              _yield$resetGoogleAut = _context5.v;
              code = _yield$resetGoogleAut.code;
              if (code === 0) {
                _this3.$message({
                  message: '重置成功',
                  type: 'success'
                });
              }
              _this3.getList();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      })));
    },
    resetPwd: function resetPwd(row) {
      var _this4 = this;
      this.$confirm('确定要重置该账号的密码吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var _yield$resetPassword, code, data;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return (0, _system.resetPassword)({
                username: row.username
              });
            case 1:
              _yield$resetPassword = _context6.v;
              code = _yield$resetPassword.code;
              data = _yield$resetPassword.data;
              if (code === 0) {
                _this4.$message({
                  message: '重置成功',
                  type: 'success'
                });
                _this4.$confirm("\u91CD\u7F6E\u540E\u7684\u767B\u9646\u5BC6\u7801\u4E3A".concat(data.pwd, "\uFF0C\u8BF7\u59A5\u5584\u4FDD\u7BA1"), '警告', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                });
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      })));
    },
    getRoleList: function () {
      var _getRoleList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7() {
        var _yield$roleList, code, data;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return (0, _system.roleList)();
            case 1:
              _yield$roleList = _context7.v;
              code = _yield$roleList.code;
              data = _yield$roleList.data;
              if (code === 0) {
                this.roleLists = data.list;
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function getRoleList() {
        return _getRoleList.apply(this, arguments);
      }
      return getRoleList;
    }(),
    getAreaList: function () {
      var _getAreaList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8() {
        var _yield$areaList, code, data;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return (0, _operation.areaList)();
            case 1:
              _yield$areaList = _context8.v;
              code = _yield$areaList.code;
              data = _yield$areaList.data;
              if (code === 0) {
                this.areaCodeList = data;
              }
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function getAreaList() {
        return _getAreaList.apply(this, arguments);
      }
      return getAreaList;
    }()
  }
};